export default __webpack_public_path__ + "static/media/faq2.37a6b86b.png";